import { useContext, useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Button } from "react-bootstrap"
import { getActas, tableData } from "./handlers"
import { renderModal } from '../handlers'
import MuniSpinner from "../../components/MuniSpinner"
import { Table } from "../../components"
import { UserContext } from "../../context"
import FormCargarActa from "./FormCargarActa"

const Actas = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [actas, setActas] = useState([])
  const [cargarActaModalIsOpen, setCargarActaModalIsOpen] = useState(false);
  const { actions: ua } = useContext(UserContext)
  const navigate = useNavigate()


  useEffect(() => {
    if (ua.hasPermission('actas.view')) {
      getActas(setIsLoading, setActas)
    } else {
      navigate('/')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <div className="d-flex gap-4 mb-4 align-items-center">
        <h3 className="mb-0">Actas</h3>
        {ua.hasPermission('actas.save_acta_backoffice') &&
          <>
            <Button onClick={() => setCargarActaModalIsOpen(true)}>Cargar Acta</Button>
            {renderModal(cargarActaModalIsOpen, setCargarActaModalIsOpen, 'Cargar acta',
              <>
                <FormCargarActa setCargarActaModalIsOpen={setCargarActaModalIsOpen} setActas={setActas} />
              </>
              , 'lg'
            )}
          </>
        }
      </div>
      {isLoading ? <MuniSpinner /> : !isLoading && actas && (
        <>
          <Table data={tableData(actas)} render={() => (
            <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: '38px' }}>
              <span>Volver</span>
            </Link>
          )} name='actas' />
        </>
      )}
    </div>
  )
}

export default Actas